<div class="app-lend-pools container-fluid" [ngClass]="httpService.theme">

    <div class="container-fluid loader" *ngIf="loading">
        <div class="loader-content">
            <cf-loader [diameter]="50"></cf-loader>
        </div>
    </div>

    <div *ngIf="!loading">
        <div class="mb-5">
            <div class="content-header d-flex w-100 align-items-center justify-content-between mb-3">
                <div class="header">
                    PayFi Vaults
                </div>
                <div class="box"
                    (click)="redirectToUrl('https://crediblefin.notion.site/How-It-Works-Credible-PayFi-Vaults-and-Permissioned-Pools-1e329dff148780a1889fca85fca2358e?pvs=4', $event)">
                    How it works?
                </div>
            </div>

            <div class="cards" *ngIf="payfi_vault_pools.length > 0">
                <div class="box" *ngFor="let i of payfi_vault_pools">
                    <cf-card [theme]="httpService.theme" type="empty">
                        <div class="header_img">
                            <img src="https://assets.credible.finance/usdc_genesis_banner.png" alt="">
                        </div>
                        <div class="content">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="logo">
                                    <img src="https://assets.credible.finance/usdc_genesis_token12.png" alt="">
                                </div>
                                <div>
                                    <div style="color: gray;">
                                        Earning
                                    </div>
                                    <div>
                                        <svg width="0.8em" height="0.8em" viewBox="0 0 16 16" fill="rgb(39, 110, 214)"
                                            xmlns="http://www.w3.org/2000/svg" class="css-67e5f8">
                                            <path d="M10.5 5.5L8 0L5.5 5.5L0 8L5.5 10.5L8 16L10.5 10.5L16 8L10.5 5.5Z"
                                                fill="rgb(39, 110, 214)"></path>
                                        </svg>
                                        <span class="ms-2">{{i.lending_yield_rates[i.lending_yield_rates.length -
                                            1].apy}}%</span>
                                    </div>
                                </div>
                            </div>

                            <div class="title mb-4">
                                {{ i.name | uppercase }}
                            </div>

                            <div style="color: gray;">
                                <div class="my-1 d-flex justify-content-between align-items-center">
                                    <span>Supplied</span>
                                    <span>${{ i.stats.tvl_usd | number : "0.0-0" }}</span>
                                </div>
                                <div class="progress-container">
                                    <div class="progress-bar" [ngStyle]="{ width: getPoolProgressPercent(i) }"></div>
                                </div>
                                <div class="my-1 d-flex justify-content-between align-items-center">
                                    <span>Limit</span>
                                    <span>${{ i.pool_size_usd | number : "0.0-4" }}</span>
                                </div>
                            </div>
                            <div class="action">
                                <cf-button (clicked)="selectPool(i)" label="Deposit" type="solid"></cf-button>

                            </div>
                        </div>


                    </cf-card>
                </div>

                <div class="box">

                    <cf-card [theme]="httpService.theme" type="empty">
                        <div class="header_img">
                            <img src="https://assets.credible.finance/usdg_genesis_banner.png" alt="">
                        </div>
                        <div class="content">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="logo">
                                    <img src="https://assets.credible.finance/usdg_genesis_token4441.png" alt="">
                                </div>
                                <div>
                                    <div style="color: gray;">
                                        Earning
                                    </div>
                                    <div>
                                        <svg width="0.8em" height="0.8em" viewBox="0 0 16 16" fill="rgb(39, 110, 214)"
                                            xmlns="http://www.w3.org/2000/svg" class="css-67e5f8">
                                            <path d="M10.5 5.5L8 0L5.5 5.5L0 8L5.5 10.5L8 16L10.5 10.5L16 8L10.5 5.5Z"
                                                fill="rgb(39, 110, 214)"></path>
                                        </svg>
                                        <span class="ms-2">16%</span>
                                    </div>
                                </div>
                            </div>

                            <div class="title mb-4">
                                USDG VAULT
                            </div>

                            <div style="color: gray;">
                                <div class="my-1 d-flex justify-content-between align-items-center">
                                    <span>Supplied</span>
                                    <span>$0</span>
                                </div>
                                <div class="progress-container">
                                    <div class="progress-bar" [ngStyle]="{ width: '0%' }"></div>
                                </div>
                                <div class="my-1 d-flex justify-content-between align-items-center">
                                    <span>Limit</span>
                                    <span>$10,000,000</span>
                                </div>
                            </div>
                            <div class="action">
                                <cf-button [disabled]="true" label="Coming Soon" type="solid"></cf-button>

                            </div>
                        </div>


                    </cf-card>
                </div>

                <div class="box">

                    <cf-card [theme]="httpService.theme" type="empty">
                        <div class="header_img">
                            <img src="https://assets.credible.finance/usdt_genesis_banner.png" alt="">
                        </div>
                        <div class="content">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="logo">
                                    <img src="https://assets.credible.finance/usdt_genesis_token2345.png" alt="">
                                </div>
                                <div>
                                    <div style="color: gray;">
                                        Earning
                                    </div>
                                    <div>
                                        <svg width="0.8em" height="0.8em" viewBox="0 0 16 16" fill="rgb(39, 110, 214)"
                                            xmlns="http://www.w3.org/2000/svg" class="css-67e5f8">
                                            <path d="M10.5 5.5L8 0L5.5 5.5L0 8L5.5 10.5L8 16L10.5 10.5L16 8L10.5 5.5Z"
                                                fill="rgb(39, 110, 214)"></path>
                                        </svg>
                                        <span class="ms-2">16%</span>
                                    </div>
                                </div>
                            </div>

                            <div class="title mb-4">
                                USDT VAULT
                            </div>

                            <div style="color: gray;">
                                <div class="my-1 d-flex justify-content-between align-items-center">
                                    <span>Supplied</span>
                                    <span>$0</span>
                                </div>
                                <div class="progress-container">
                                    <div class="progress-bar" [ngStyle]="{ width: '0%' }"></div>
                                </div>
                                <div class="my-1 d-flex justify-content-between align-items-center">
                                    <span>Limit</span>
                                    <span>$10,000,000</span>
                                </div>
                            </div>
                            <div class="action">
                                <cf-button [disabled]="true" label="Coming Soon" type="solid"></cf-button>

                            </div>
                        </div>


                    </cf-card>
                </div>
            </div>
        </div>

        <div>
            <div class="header mb-3">
                Permissioned Pools
            </div>
            <div class="row" *ngIf="mobile_layout === 'grid'">
                <div class="col-md-12">
                    <div class="pools-grid-container">
                        <div *ngFor="let pool of pools">
                            <app-lend-default [pool]="pool"
                                *ngIf="pool.category_id === 'private-credit'"></app-lend-default>
                            <app-lend-default [pool]="pool"
                                *ngIf="pool.category_id === 'partner-protocol'"></app-lend-default>
                            <app-lend-default [pool]="pool" *ngIf="pool.category_id === 'vault'"></app-lend-default>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="mobile_layout !== 'grid'">
                <cf-card [theme]="httpService.theme" type="empty">
                    <div class="pools-list-container">
                        <table>
                            <thead>
                                <th>Company</th>
                                <th>TVL</th>
                                <th>APY</th>
                                <th>Rating</th>
                                <th>Verifier</th>
                                <th>Tenor</th>
                                <th></th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let pool of permissioned_pools"
                                    [matTooltip]="pool.coming_soon ? 'Coming Soon' : ''"
                                    [ngClass]="{ 'pool-disabled': pool.coming_soon }">
                                    <td class="pool-name-container">
                                        <div class="d-flex align-items-center">
                                            <img style="border-radius: 100%;" [src]="pool.image_url" width="26"
                                                [alt]="pool.name" />
                                            <span class="ms-3">
                                                {{ pool.name }}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        {{ pool.stats.tvl_usd | number:'0.0-0' }} USD
                                    </td>
                                    <td>{{ pool.lending_yield_rates[pool.lending_yield_rates.length - 1].apy
                                        }}%
                                    </td>
                                    <td>
                                        <span *ngIf="pool.borrower_overview.rating_agency_equivalent">
                                            {{ pool.borrower_overview.rating_agency_equivalent }}
                                        </span>
                                        <span *ngIf="!pool.borrower_overview.rating_agency_equivalent">
                                            Unrated
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="pool.borrower_overview.rating_agency_equivalent">
                                            {{ pool.borrower_overview.rating_agency }}
                                            <i class="fa-solid fa-up-right-from-square"
                                                *ngIf="pool.borrower_overview.rating_agency"
                                                (click)="redirectToUrl(pool.borrower_overview.rating_agency_url, $event)"></i>
                                        </span>
                                        <span *ngIf="!pool.borrower_overview.rating_agency_equivalent">
                                            Unrated
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="pool.tenor === 0">Flexible</span>
                                        <span *ngIf="pool.tenor > 0">{{ pool.tenor }} days</span>
                                    </td>
                                    <td>
                                        <cf-button label="Deposit" (clicked)="selectPool(pool)"
                                            type="solid"></cf-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </cf-card>
            </div>


        </div>
    </div>

</div>